import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';
import { InitiateTarriffComponent } from '../initiate-tarriff/initiate-tarriff.component';

@Component({
  selector: 'app-update-dialog',
  templateUrl: './update-dialog.component.html',
  styleUrls: ['./update-dialog.component.scss']
})
export class UpdateDialogComponent implements OnInit {
  @Output() refreshTableData = new EventEmitter();
  updateForm: FormGroup;
  loadPage: boolean;
  vpmnCountry: any = [];
  vpmnNetwork: any = [];
  moCallHome: any = [];
  moCallOther: any = [];
  moCallVisited: any = [];
  moSms: any = [];
  tarrifId: any = [];
  tarrifName: any = [];
  tarrif1: any = [];
  tarrif2: any = [];
  tarrif3: any = [];
  tarrif4: any = [];
  tarrif5: any = [];
  tarrif6: any = [];
  tarrif7: any = [];
  tarriffData: [];
  tarriffData1: [];
  tarriffData2: [];
  itemData: any;
  callVPMNNetwork: boolean;
  submitted = false;  

  constructor(private dialogRef: MatDialogRef<InitiateTarriffComponent>,
    private formBuilder: FormBuilder,
    private router: Router, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinnerService: Ng4LoadingSpinnerService,
    private endpointsService: EndpointsService,
    private backendApiService: BackendApiService) {
    this.spinnerService.show();
  }

  ngOnInit(): void {
    this.itemData = this.data.rowData;
    
    this.getApiOnLoad();
    this.createTarriffForm();
    this.loadPage = true;
  }

  createTarriffForm() {
    this.updateForm = this.formBuilder.group({
      // vpmnCountry: [this.itemData.vpmnCountry],
      vpmnCountry: [this.itemData.country, Validators.required],
      vpmnNetwork: [this.itemData.network.split('_')[0] , Validators.required],
      moCallHome: [this.itemData.moCallHome, Validators.required],
      moCallOther: [this.itemData.moCallOther, Validators.required],
      moCallVisited: [this.itemData.moCallVisited, Validators.required],
      gprs: [this.itemData.gprs, Validators.required],
      moSms: [this.itemData.moSms, Validators.required],
      tarrifId: [this.itemData.tarrifId, Validators.required],
      tarrifName: [this.itemData.tarrifName, Validators.required],
      tarrif1: [this.itemData.tarrif1],
      tarrif2: [this.itemData.tarrif2],
      tarrif3: [this.itemData.tarrif3],
      tarrif4: [this.itemData.tarrif4],
      tarrif5: [this.itemData.tarrif5],
      tarrif6: [this.itemData.tarrif6],
      tarrif7: [this.itemData.tarrif7],
      startDate: [this.itemData.startDate],
      endDate: [this.itemData.endDate],
      sno: [this.itemData.sno]
    });

    // this.updateForm.patchValue(this.itemData.country)
    // this.updateForm.patchValue({ vpmnNetwork: this.itemData.network.split('_')[0] })
    // this.updateForm.controls.vpmnNetwork.patchValue(this.itemData.network.split('_')[0])

    
  }


  get f() {
    return this.updateForm.controls;
  }

  async getApiOnLoad() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');

    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.tarriffData1 = response;
    });
    this.getVpmnNetworkList(this.itemData.country).then();
  }


  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === '1') {
      this.callVPMNNetwork = false;
      // this.updateForm.controls.vpmnNetwork.setValue('1', { onlySelf: true });
    } else {
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;

    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.tarriffData2 = response;
      // if (this.tarriffData2 && this.tarriffData2.length > 0) {
      //   this.updateForm.controls.vpmnNetwork.setValue(response[0].operator, { onlySelf: true });
      // }

    });

  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }

  onClose() {
    this.dialogRef.close();
  }

  onUpdate() {
    this.spinnerService.show();
    this.submitted = true;
    if (this.updateForm.invalid) {
      return;
    }
    if(this.updateForm.get('vpmnNetwork').value != 'ALL'){
    
    this.backendApiService.callToApi(this.endpointsService.URL_UPDATE_TARRIFF + '&country=' +
      this.updateForm.get('vpmnCountry').value + '&network=' +
      this.updateForm.get('vpmnNetwork').value + '&startDate=' +
      this.updateForm.get('startDate').value + '&endDate=' +
      this.updateForm.get('endDate').value + '&moCallHome=' +
      this.updateForm.get('moCallHome').value + '&moCallOther=' +
      this.updateForm.get('moCallOther').value + '&moCallVisited=' +
      this.updateForm.get('moCallVisited').value + '&moSms=' +
      this.updateForm.get('moSms').value + '&gprs=' +
      this.updateForm.get('gprs').value + '&tarrif1=' +
      this.updateForm.get('tarrif1').value + '&tarrif2=' +
      this.updateForm.get('tarrif2').value + '&tarrif3=' +
      this.updateForm.get('tarrif3').value + '&tarrif4=' +
      this.updateForm.get('tarrif4').value + '&tarrif5=' +
      this.updateForm.get('tarrif5').value + '&tarrif6=' +
      this.updateForm.get('tarrif6').value + '&tarrif7=' +
      this.updateForm.get('tarrif7').value + '&tarrifName=' +
      this.updateForm.get('tarrifName').value + '&tarrifId=' +
      this.updateForm.get('tarrifId').value + '&sno=' +
      this.updateForm.get('sno').value + '&userName=' + sessionStorage.getItem('ecowas_user_name')
      + '&userOrgId=' + sessionStorage.getItem('userOrgId'))
      .subscribe(response => {
        
        this.spinnerService.hide();

        if (response === null) {
          alert('Update Tariff failed, please contact to Administrator');
          return;
        } else {
          alert('Tariff Updated successfully');
          this.dialogRef.close();
          this.refreshTableData.emit();
        }
      });

  }
else{
alert('Please Select VPMN Network')
}
  }
}